import React from "react";
import clx from "classnames";
import Link from "next/link";
import Image from "next/image";

import ButtonNoStyles from "../../common/Buttons/ButtonNoStyles/ButtonNoStyles";
import NotificationFlyout from "../../Notifications/NotificationFlyout/NotificationFlyout";
import AccountDropdown from "../../Dropdown/AccountDropdown/AccountDropdown";
import HelpDropdown from "../../Dropdown/HelpDropdown/HelpDropdown";
import Icon from "../../common/Icon/Icon";
import Typography from "../../common/Typography/Typography";
import Pill from "../../common/Pill/Pill";
import styles from "./Header.module.css";
import SideNavFlyout from "../SideNavFlyout/SideNavFlyout";

interface Props {
    notification: boolean;
}

const Header = ({ notification }: Props) => {
    const cn = clx(
        {
            [styles.notificationDot]: notification === true,
        },
        "w-full relative"
    );

    const pillCn = clx({
        block: notification === true,
        hidden: notification === false,
    });

    return (
        <header className={styles.header}>
            <div className={styles.headerContainer}>
                <Link href="/" title="Dashboard">
                    <Image src="/logos/vergo-logo-watermark.svg" width={31} height={35} alt="logo" className="inline-flex xs:hidden" />
                    <Image
                        src="/logos/vergo-hub-logo-light.svg"
                        width={110}
                        height={54}
                        alt="vergo logo"
                        className="hidden xs:inline-flex"
                    />
                </Link>
                <div className="flex gap-0.5 items-center">
                    <div className="hidden">
                        <NotificationFlyout>
                            <ButtonNoStyles className={styles.headerButton}>
                                <div className={`relative ${cn}`}>
                                    <Icon icon="bell" width={21} height={21} />
                                </div>
                                <Pill className={pillCn}>7</Pill>
                            </ButtonNoStyles>
                        </NotificationFlyout>
                    </div>

                    <HelpDropdown />
                    <AccountDropdown />

                    <SideNavFlyout>
                        <ButtonNoStyles className={`${styles.headerButton} min-[1130px]:!hidden`}>
                            <Icon icon="menu" width={21} height={21} />
                            <Typography as="span" variant="smallCaps" color="white" className="hidden xs:block">
                                menu
                            </Typography>
                        </ButtonNoStyles>
                    </SideNavFlyout>
                </div>
            </div>
        </header>
    );
};

export default Header;
